import { useContext } from 'react'

import { AnalyticsContext } from '~/app/features/FragmentRoot/contexts/gallery/AnalyticsContext'
import type { IAnalytics } from 'shared/analytics/interface'

export const useAnalytics = (): IAnalytics => useContext(AnalyticsContext) as IAnalytics
